import { createEntityAdapter, createSelector, createSlice } from '@reduxjs/toolkit';

import { CREATE_ERROR } from 'FRONTEND/utils/constants';

const REDUCER_NAME = 'appointment';
const appointmentAdapter = createEntityAdapter({
  selectId: ({ appointmentId }) => appointmentId,
  sortComparer: (a, b) => a.start > b.start ? 1 : a.start < b.start ? -1 : 0,
});

// Relative selector for usage in the reducer
const { selectAll: selectAllAppointmentsRelatively } = appointmentAdapter.getSelectors();
const selectExpertAppointmentIdListRelatively = createSelector(
  selectAllAppointmentsRelatively,
  (_, actorId) => actorId,
  (appointmentList, actorId) => {
    return appointmentList.filter((appointment) => appointment.actorId === actorId).map((appointment) => appointment.appointmentId);
  },
);

const initialState = {
  ...appointmentAdapter.getInitialState(),
  proposedCount: 0,
  errorType: null,
  error: null,
};

const appointmentSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    listRequest(state, { payload: { actorId, startDate, endDate, withTime } = {} }) {},
    listSuccess(state, { payload: { appointments } }) {
      appointmentAdapter.upsertMany(state, appointments);
    },
    listError(state, { payload: { error } }) {
      state.error = error;
    },
    clear(state, { payload: { actorId } }) {
      if (actorId) {
        appointmentAdapter.removeMany(state, selectExpertAppointmentIdListRelatively(state, actorId));
      } else {
        appointmentAdapter.removeAll(state);
      }
    },
    createRequest(state) {},
    createSuccess(state, { payload: { appointment } }) {
      appointmentAdapter.addOne(state, appointment);
      state.selectedSlot = null;
      state.selectedType = null;
    },
    createError(state, { payload: { error } }) {
      state.errorType = CREATE_ERROR;
      state.error = error;
    },
    updateRequest(state, { payload }) {
    },
    updateSuccess(state, { payload: { appointment: { appointmentId, ...changes } } }) {
      appointmentAdapter.updateOne(state, { id: appointmentId, changes });
    },
    updateError(state, { payload }) {
      state.error = payload.error;
    },
    cancelRequest(state, { payload }) {},
    cancelSuccess(state, { payload: { appointment: { appointmentId, ...changes } } }) {
      appointmentAdapter.updateOne(state, { id: appointmentId, changes });
    },
    cancelError(state, { payload }) {
      state.error = payload.error;
    },
  },
});
// Global selectors for usage in components and middlewares
export const {
  selectById: selectAppointmentById,
  selectAll: selectAllAppointments,
} = appointmentAdapter.getSelectors((state) => state.appointment);

export const selectAppointmentsWithLocation = createSelector(
  selectAllAppointments,
  (appointmentList) => {
    return appointmentList.filter((appointment) => appointment.location);
  },
);

export const selectAppointmentsWithLocationByActorId = createSelector(
  selectAllAppointments,
  (_, actorId) => actorId,
  (appointmentList, actorId) => {
    const filteredByActor = appointmentList.filter((appointment) => {
      return appointment.participant.some((p) => {
        return Array.isArray(actorId) ? actorId.includes(p.actor.id) : p.actor.id === actorId;
      });
    });
    return filteredByActor.filter((appointment) => appointment.location);
  },
);

export const {
  listRequest,
  listSuccess,
  listError,
  clear,
  createRequest,
  createSuccess,
  createError,
  updateRequest,
  updateSuccess,
  updateError,
  updateCheckedLocationsList,
  cancelRequest,
  cancelSuccess,
  cancelError,
} = appointmentSlice.actions;
export default appointmentSlice.reducer;
